import { gql } from "@apollo/client";

export const ANNOUNCEMENT = gql`
query Announcement($code_in: [String]!, $culture: String!) {
  airport(where: {code: {code_in: $code_in}, localization: {culture: $culture}}) {
    code {
      code
    }
    announcements {
      contentItems {
          __typename
          ... on Announcement {
          displayText
          level
          booking
          checkIn
          departure
          arrival
          htmlBody {
            html
          }
          news {
            contentItems {
                contentItemId
                __typename
                ... on News {
                content {
                  contentItems {
                    contentItemId
                    contentType
                  }
                }
              }
            }
          }
        }
      }
    }
    city {
      contentItems {
          __typename
          ... on City {
          country {
            contentItems {
              __typename
              ... on Country {
                announcements {
                  contentItems {
                    __typename
                    ... on Announcement {
                      displayText
                      level
                      booking
                      checkIn
                      departure
                      arrival
                      htmlBody {
                        html
                      }
                      news {
                        contentItems {
                          contentItemId
                          __typename
                          ... on News {
                            content {
                              contentItems {
                                contentItemId
                                contentType
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`